<template>
    <v-layout justify-center row>
        <v-dialog max-width="500px" persistent v-model="dialog" @keydown.esc="close">
            <v-card>
                <v-card-title class="justify-center white--text secondary" >
                    <span class="headline">Επεξεργασία Στοιχείων Επικοινωνίας</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout align-space-around column fill-height justify-space-around>
                            <v-form
                                    @submit.prevent
                                    lazy-validation
                                    ref="form"
                                    v-model="valid">
                                <v-flex xs12>
                                    <v-text-field :rules="emailRules" clearable label="Προσωπικό E-mail Επικοινωνίας"
                                                  prepend-inner-icon="email" required
                                                  v-model="email"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field :counter="10" :rules="phoneRules" clearable
                                                  label="Αριθμός Κινητού Τηλεφώνου" prepend-inner-icon="phone" required
                                                  v-model="mobile"></v-text-field>
                                </v-flex>
                            </v-form>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" color="primary darken-0" flat>Ακύρωση</v-btn>
                    <v-btn @click="save" color="primary darken-0" >Αποθήκευση</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import requests from "../../requests";


    export default {
        name: "StudentCredentialsEdit",
        data: () => ({
            mobile: '',
            email: '',
            valid: false,
            emailRules: [
                v => !!v || 'Το email είναι απαραίτητο ',
                v => /^[A-Za-z][-.\w]*@([-\w]+\.)+[A-Za-z]{2,}$/.test(v) || 'Το email δεν είναι έγκυρο'
            ],
            phoneRules: [
                v => !!v || 'Το τηλέφωνο είναι απαραίτητο',
                v =>  /^69[0-9]{8}$/.test(v) || 'Το τηλέφωνο δεν είναι έγκυρο'
            ]
        }),
        props: {
            dialog: Boolean
        },
        methods: {
            close() {
                this.$emit('dialogClose', false);
                // this.$refs.form.resetValidation();
                // this.$refs.form.reset();
            },
            saveCredentialsSuccess(response) {
                var loginObject = this.$store.getters.login;
                loginObject.personalEmail = response.personalEmail;
                loginObject.mobile = response.mobile;
                this.$store.commit('setLogin', loginObject);
                this.$emit('changeCredentials');
                this.$store.commit('setLoadingModal', false);
                this.$emit('dialogSave', false);
            },
            save() {
                if(this.validateEmail() && this.validateMobile()){
                    this.$store.commit('setLoadingModal', true);
                    let requestCredentials = {
                        email: this.email,
                        mobile: this.mobile,
                        courseCountBeforeEudoxos: this.$store.getters.login.courseCountBeforeEudoxos,
                        currentSemester: this.$store.getters.login.currentSemester,
                        hasAcceptedSecondTerm: null
                    };
                    requests.saveCredentials(requestCredentials, this.saveCredentialsSuccess);
                    // this.$refs.form.resetValidation();
                    // this.$refs.form.reset();
                }
                else if(!this.validateEmail()) {
                    alert("Το email δεν είναι έγκυρο");
                    this.email = '';
                }
                else if(!this.validateMobile()){
                    alert('Το τηλέφωνο δεν είναι έγκυρο');
                    this.mobile = '';
                }

            },
            validateEmail() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(this.email).toLowerCase());
            },
            validateMobile(){
                var re = /^69[0-9]{8}$/;
                return re.test(this.mobile);
            }
        },
        mounted(){
            this.email = this.$store.getters.login.personalEmail;
            this.mobile = this.$store.getters.login.mobile;
        }
    }
</script>

<style scoped>

</style>
